/**
 * Shared help copy for SS Unit hub (page Info + modal Info).
 */
export function UnitHubInfoContent({ unitIdHint, ssCode }) {
  return (
    <div className="space-y-4 text-sm">
      <p>
        <strong>What this screen is</strong>
        <br />
        The <strong>Unit hub</strong> is the single place to set everything for one specified-system unit on this
        building: identity, inspection frequency/method, the confirmed checklist questions used on site, and
        photos/documents. Default IQP is set at the SS level (header chip). Edit here and <strong>Save</strong> —
        the same registry record is used on the floor plan, SS Units list, Order/Inspections, and the worker app.
      </p>

      <p>
        <strong>Identity (Unit ID)</strong>
        <br />
        Format is usually <code className="text-xs bg-gray-100 px-1 rounded">SS-code-number</code> (e.g.{' '}
        <code className="text-xs bg-gray-100 px-1 rounded">1.1-1</code>
        {unitIdHint ? (
          <>
            ; this unit: <code className="text-xs bg-gray-100 px-1 rounded">{unitIdHint}</code>
          </>
        ) : null}
        {ssCode ? (
          <>
            {' '}
            for <strong>{ssCode}</strong>
          </>
        ) : null}
        ). On this hub, only the <strong>number after the dash</strong> can change. The SS prefix stays fixed so
        IDs stay consistent with the Compliance Schedule. A number already used by another unit in this building
        cannot be reused ?? pick a free suffix.
      </p>

      <p>
        <strong>Location, level, make/model</strong>
        <br />
        Location label is the short site description (e.g. “Sprinkler Valve Room door”). Level/floor links the unit
        to a floor-plan level. Manufacturer, model, serial, and installation year support identification on site and
        on Form 12A / reports.
      </p>

      <p>
        <strong>Unit type</strong>
        <br />
        Optional equipment type (e.g. Magnetic lock, Swing door). Units that share the same type can share one{' '}
        <strong>type-specific checklist pool</strong>. Use a clear, consistent name so questionnaires stay grouped.
      </p>

      <p>
        <strong>Frequency &amp; method</strong>
        <br />
        How often this unit is inspected (annual, monthly, …) and whether the procedure is the same every time or
        varies by period. Notes / period table feed scheduling and the inspector’s procedure text.
      </p>

      <p>
        <strong>Default IQP (assignee)</strong>
        <br />
        Set at the <strong>SS level</strong> (specified system), not per unit ?? use the chip in the unit hub
        header or SS detail. One default IQP or external company applies to <strong>all units</strong> under that
        SS. This drives BWOF progress “IQP”, notify emails, and job defaults.
      </p>

      <p>
        <strong>Set Inspection List</strong>
        <br />
        Open an <strong>equipment type</strong> — questions are checked by default. Press <strong>Select</strong> to
        copy them into the Selected list. Copied pool items stay disabled until removed from Selected. Add private
        questions (category, text, measurement criteria, auto or manual Pass/Fail). <strong>Save</strong> makes this
        the unit’s only inspection list on the worker app. Fail on site requires a reason plus camera or upload photo
        (evidence for defect reports).
      </p>

      <p>
        <strong>Photos &amp; documents</strong>
        <br />
        Take a camera photo or upload images/PDFs for this unit ?? nameplate, installation manual, certificates,
        as-built notes. Files stay attached to this unit record for later reference.
      </p>

      <p className="text-gray-600 text-xs">
        Tip: After changing ID or checklist, always press <strong>Save</strong> at the bottom so floor plan and
        inspections stay in sync. Default IQP is saved separately from the SS header chip.
      </p>
    </div>
  );
}
